import { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  useEffect(() => {
    // Redirect the user to the specified URL
    window.location.replace("https://www.imimpower.com/");
  }, []);

  return (
    <div className="App">
    </div>
  );
}

export default App;
